var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Z-Отчеты"),_c('br'),_vm._v(" P:"+_vm._s(_vm.period)),_c('br'),_vm._v(" C:"+_vm._s(_vm.company)),_c('br'),_c('line-chart',{attrs:{"styles":_vm.chartStyle,"chart-data":_vm.datacollection,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }